import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import React, { useEffect, useState } from "react";
import index from "./pages/Home";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import Index from "./pages/Contact/Index";
import { axiosInstance, config } from "./pages/config";
import AboutUs from "./pages/About/AboutUs";
import ProductDetails from "./pages/Product/ProductDetails";
import "./assets/styles/About.css";
import Loader from "./components/common/Loader";
import ScrollToTop from "./components/common/ScrollToTop";
import Footer from "./components/common/Footer";
import ProductMain from "./pages/Product/ProductMain";
import SearchResults from "./components/common/SearchResults";
import Product from "./pages/Product/Product";
function App() {
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    setTimeout(() => setLoading(false), 1900)
  }, [])
  if (loading) {
    return <Loader />
  }

  return (
    <div>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path={`${config.appUrl}`} Component={index} />
          <Route path={`${config.appUrl}contact-us`} Component={Index} />
          <Route path={`${config.appUrl}about-us`} Component={AboutUs} />
          <Route path={`${config.appUrl}product`} Component={Product} />
          <Route path={`${config.appUrl}:slug`} Component={ProductDetails} />
          <Route path={`${config.appUrl}:slug/:productId`} Component={ProductMain} />
          <Route path={`${config.appUrl}search/:slug`} Component={SearchResults} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
